import projection from '../generated/pwd5n4f1.json';
import { AcceptanceManifest } from '../types';
export const pwd5n4f1AcceptanceManifest = projection as AcceptanceManifest;
